import React, { useEffect, useState } from "react";

import { Close, Fullscreen } from "assets/icons";
import { IEmbed, ButtonTheme } from "types";
import { IconButton, EmbedCode } from "components";
import classNames from "classnames";
import { useCloseOnEscape } from "utils";
import { i18nService } from "services";

interface EmbedProps extends IEmbed {
  blockElement: HTMLElement | null;
}

const HIDE_CLASS = "is-invisible";
const SHOW_CLASS = "is-visible";

export const Embed: React.FC<EmbedProps> = ({
  embed,
  allowEnlarge,
  blockElement,
}) => {
  const [isFullscreen, setFullscreen] = useState(false);

  useCloseOnEscape(() => setFullscreen(false));

  useEffect(() => {
    if (isFullscreen) return;

    document.body.classList.remove(HIDE_CLASS);
    blockElement?.classList.remove(SHOW_CLASS);
  }, [isFullscreen, blockElement]);

  const handleFullscreenClick = () => {
    document.body.classList.add(HIDE_CLASS);

    setFullscreen(true);
    blockElement?.classList.add(SHOW_CLASS);
  };

  return (
    <div
      className={classNames("embed", [isFullscreen && "embed-modal is-fullscreen"])}
    >
      {allowEnlarge && !isFullscreen && (
        <button
          className="embed__fullscreen"
          type="button"
          onClick={handleFullscreenClick}
        >
          <span className="embed__fullscreen-icon">
            <Fullscreen />
          </span>
          <span className="embed__fullscreen-label">
            {i18nService.copy["embed.viewFullscreen"]}
          </span>
        </button>
      )}
      {isFullscreen && (
        <IconButton
          className="modal__close"
          label={i18nService.copy["a11y.close"]}
          Icon={Close}
          theme={ButtonTheme.secondary}
          onClick={() => setFullscreen(false)}
        />
      )}
      <div className="embed__embed">
        <EmbedCode embed={embed} />
      </div>
    </div>
  );
};
